module.exports = "mutation createProductDocs($id: ID!) {\n  createProductDocs(input: {id: $id}) {\n    envelope {\n      id\n      slug\n    }\n  }\n}\n"